import { debug } from "../../utils";

export const ACTION_MSB_LIST_CHANGED = "ACTION_MSB_LIST_CHANGED";
export const ACTION_DEVICE_TYPES_CHANGED = "ACTION_DEVICE_TYPES_CHANGED";
export const ACTION_RULE_CATEGORIES_CHANGED = "ACTION_RULE_CATEGORIES_CHANGED";
export const ACTION_RULES_CHANGED = "ACTION_RULES_CHANGED";
export const ACTION_TARGET_TYPE_TIMESTAMP_CHANGED = "ACTION_TARGET_TYPE_TIMESTAMP_CHANGED";
export const ACTION_TARGET_TYPES_CHANGED = "ACTION_TARGET_TYPES_CHANGED";
export const ACTION_TARGET_TYPES_LOADING_CHANGED = "ACTION_TARGET_TYPES_LOADING_CHANGED";

const initState = {
    targetTypes: {},
    targetTypesLoading: true
};

export function MsbPageReducer(state = initState, action) {
    switch (action.type) {
        case ACTION_MSB_LIST_CHANGED: {
            debug(`MsbPageReducer ${ACTION_MSB_LIST_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_DEVICE_TYPES_CHANGED: {
            debug(`MsbPageReducer ${ACTION_DEVICE_TYPES_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_RULE_CATEGORIES_CHANGED: {
            debug(`MsbPageReducer ${ACTION_RULE_CATEGORIES_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_RULES_CHANGED: {
            debug(`MsbPageReducer ${ACTION_RULES_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_TARGET_TYPE_TIMESTAMP_CHANGED: {
            debug(`MsbPageReducer ${ACTION_TARGET_TYPE_TIMESTAMP_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_TARGET_TYPES_CHANGED: {
            debug(`MsbPageReducer ${ACTION_TARGET_TYPES_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_TARGET_TYPES_LOADING_CHANGED: {
            debug(`MsbPageReducer ${ACTION_TARGET_TYPES_LOADING_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}
